export default __webpack_public_path__ + "static/media/image.1afd0ece.svg";